// create a countdonw component which takes startDateTime and endDateTime as props and shows the time remaining in days, hours, minutes and seconds format
// if endDateTime is less than startDateTime, show 0s
// if either of the props is not provided or invalid date, show N/A

import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import dayjs from 'dayjs'

/**
 * CountDown Component
 * Props:
 * - startDateTime: start date time (Date or string)
 * - endDateTime: end date time (Date or string)
 * - onComplete: callback when countdown completes
 */



const CountDown = ({ startDateTime, endDateTime, onComplete }) => {
  const [timeRemaining, setTimeRemaining] = useState('N/A');
  const [completed, setCompleted] = useState(false);

  useEffect(() => {
    // Use current date if not provided
    const start = startDateTime ? dayjs(startDateTime) : dayjs();
    const end = endDateTime ? dayjs(endDateTime) : dayjs();

    if (!start.isValid() || !end.isValid()) {
      setTimeRemaining('N/A');
      return;
    }

    if (end.isBefore(start)) {
      setTimeRemaining('N/A');
      if (!completed && onComplete) {
        setCompleted(true);
        onComplete();
      }
      return;
    }

    const updateCountdown = () => {
      const now = dayjs();
      if (now.isAfter(end)) {
        setTimeRemaining('N/A');
        if (!completed && onComplete) {
          setCompleted(true);
          onComplete();
        }
        return;
      }
      const totalSeconds = end.diff(now, 'seconds');
      const days = Math.floor(totalSeconds / (24 * 3600));
      const hours = Math.floor((totalSeconds % (24 * 3600)) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      setTimeRemaining(`${days}d ${hours}h ${minutes}m ${seconds}s`);
    };

    setCompleted(false);
    updateCountdown();
    const intervalId = setInterval(updateCountdown, 1000);
    return () => clearInterval(intervalId);
  }, [startDateTime, endDateTime, onComplete, completed]);

  return <span>{timeRemaining}</span>;
}

CountDown.propTypes = {
  startDateTime: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.string,
  ]),
  endDateTime: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.string,
  ]),
  onComplete: PropTypes.func,
}

CountDown.defaultProps = {
  startDateTime: null,
  endDateTime: null,
  onComplete: null,
}

export default CountDown